import { render, staticRenderFns } from "./bomCreate.vue?vue&type=template&id=7321f9b4"
import script from "./bomCreate.vue?vue&type=script&lang=js"
export * from "./bomCreate.vue?vue&type=script&lang=js"
import style0 from "./bomCreate.vue?vue&type=style&index=0&id=7321f9b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports